import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { gql } from '../graphql/generated';
import { isCommentOrPublicCommentThread } from '../utils/post/threadUtils';
import commentThreadPath from '../utils/url/commentThreadPath';

const HISTORICAL_COMMENT_THREAD_QUERY = gql(/** @complexity 3 */ `
  query HistoricalCommentThread($id: ID!) {
    post(id: $id) {
      id
      title
      threads(historical: true) {
        id
        resolvedAt
        version
      }
    }
  }
`);

function useLazyHistoricalCommentThreadPath() {
  const [getPostData] = useLazyQuery(HISTORICAL_COMMENT_THREAD_QUERY);

  return useCallback(
    async (postId: string, threadId: string) => {
      const { data } = await getPostData({ variables: { id: postId } });
      const post = data?.post;
      const threads = post ? post.threads : [];
      const thread = threads.find((t) => t.id === threadId);

      return post &&
        thread?.resolvedAt != null &&
        isCommentOrPublicCommentThread(thread)
        ? commentThreadPath({
            ...thread,
            version: thread.version,
            resolvedAt: thread.resolvedAt,
            // instead of spreading commentThreadPath on thread, I construct the post object like this
            // so that we don't need to load the post for each thread
            post: {
              id: postId,
              title: post.title,
            },
          })
        : undefined;
    },
    [getPostData],
  );
}

export default useLazyHistoricalCommentThreadPath;
